/** One-way cleanup for the retired Cosimo analytics project. No SDK or transport. */
const RETIRED_PROJECT_DIGESTS = new Set([
  // SHA-256 of the public project namespace in the deployed Cosimo bundle.
  "df9f249adf80ae7494fa8cc1cb66e9eed8243f6b43547fbc1370d8668028ccdf",
]);

function projectNamespace(key: string): string | undefined {
  return (
    /^ph_(phc_[A-Za-z0-9_+/=-]+)_(?:posthog|window_id|primary_window_exists)$/.exec(key)?.[1] ??
    /^ph_cosimo_(phc_[A-Za-z0-9_+/=-]+)_[a-f0-9]{32}(?:_window_id|_primary_window_exists)?$/.exec(
      key
    )?.[1] ??
    /^__ph_opt_in_out_(phc_[A-Za-z0-9_+/=-]+)$/.exec(key)?.[1]
  );
}

async function matchesProject(key: string, digests: ReadonlySet<string>): Promise<boolean> {
  const project = projectNamespace(key);
  if (!project) return false;
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(project));
  return digests.has(
    Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("")
  );
}

/** Preserve auth, preferences, guest chat identity and other projects on this origin. */
export async function clearRetiredAnalyticsStorage(
  digests: ReadonlySet<string> = RETIRED_PROJECT_DIGESTS
): Promise<void> {
  if (typeof window === "undefined") return;
  for (const getStorage of [() => window.localStorage, () => window.sessionStorage]) {
    try {
      const storage = getStorage();
      const keys = Array.from({ length: storage.length }, (_, index) => storage.key(index));
      for (const key of keys) {
        if (key && (await matchesProject(key, digests))) storage.removeItem(key);
      }
      // This marker was exclusively the retired signup event's pending queue.
      storage.removeItem("cosimo_pending_signup");
    } catch {
      // Retry on the next reachable document; blocked/offline storage is not certified cleared.
    }
  }
  try {
    for (const part of document.cookie.split(";")) {
      const key = decodeURIComponent(part.trim().split("=", 1)[0]);
      if (!(await matchesProject(key, digests))) continue;
      const cookie = `${encodeURIComponent(key)}=; Max-Age=0; path=/`;
      document.cookie = cookie;
      const labels = window.location.hostname.split(".");
      for (let start = 0; start < labels.length - 1; start++) {
        const domain = labels.slice(start).join(".");
        document.cookie = `${cookie}; domain=${domain}`;
        document.cookie = `${cookie}; domain=.${domain}`;
      }
    }
  } catch {
    // Cookies may be unavailable independently of web storage.
  }
}
